// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2eHPl","header":"PatientBlock_header___u5ug","label":"PatientBlock_label__2qX3H","option":"PatientBlock_option__1n6Dt"};